import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "drawer";
var attributes = {
    OPEN: 'open',
    TYPE: 'type',
    DIRECTION: 'direction',
    AUTO_CLOSE: 'auto-close'
};
var classes = {
    DRAWER: 'tyl-drawer',
    ROOT: 'tyl-drawer__root',
    MINI: 'tyl-drawer--mini',
    MINI_HOVER: 'tyl-drawer--mini-hover',
    MODAL: 'tyl-drawer--modal',
    CLOSED: 'tyl-drawer--closed',
    LEFT: 'tyl-drawer--left',
    RIGHT: 'tyl-drawer--right',
    DISPLAY_NONE: 'tyl-drawer--display-none',
    NO_TRANSITION: 'tyl-drawer--no-transition'
};
var selectors = {
    DRAWER: "." + classes.DRAWER,
    ROOT: "." + classes.ROOT
};
var events = {
    CLOSE: elementName + "-close",
    AFTER_OPEN: elementName + "-after-open",
    AFTER_CLOSE: elementName + "-after-close"
};
export var DRAWER_CONSTANTS = {
    elementName: elementName,
    attributes: attributes,
    classes: classes,
    selectors: selectors,
    events: events
};
